interface Props {
  value: number | string;
  label: string;
  accent?: boolean;
}

export function Stat({ value, label, accent }: Props) {
  return (
    <div>
      <div
        style={{
          fontFamily: "var(--display)",
          fontSize: 30,
          fontWeight: 400,
          color: accent ? "var(--accent)" : "var(--ink)",
          letterSpacing: -0.8,
          fontVariantNumeric: "tabular-nums",
          lineHeight: 1,
        }}
      >
        {value}
      </div>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.6,
          color: "var(--ink-soft)",
          marginTop: 6,
        }}
      >
        {label}
      </div>
    </div>
  );
}
